import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { logActivity } from 'lib/activity';
/** Only pathname changes count as visits, not filters or button clicks. */
export function ActivityTracker() {
  const { pathname } = useLocation();
  const lastPage = useRef<string>();
  useEffect(() => {
    if (lastPage.current !== pathname) {
      lastPage.current = pathname;
      void logActivity(pathname);
    }
  }, [pathname]);
  return null;
}
